import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: '0 0 12px 0',
    fontSize: 20,
    fontWeight: 'bold',
    color: '#7833FF',
    textAlign: 'center',
  },
  subtitle: {
    display: 'none',
    fontSize: 14,
    color: '#757575',
    margin: '0 0 30px 0',
    textAlign: 'center',
    lineHeight: '1.5rem',

    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  itemContainer: {
    marginTop: 0,
    marginBottom: 0,
  },
  item: {
    textAlign: 'center',

    '& img': {
      height: 75,
    },

    '& h2': {
      color: '#7833FF',
      fontSize: 20,
      fontFamily: 'Arial',
      fontWeight: 'bold',
      marginTop: 17,
    },
  },
  desktopText: {
    display: 'none',

    [theme.breakpoints.up('md')]: {
      display: 'inline',
    },
  },
  mobileText: {
    display: 'inline',

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  builtMind: {
    color: '#170E09',
    fontSize: 16,
    fontFamily: 'Arial',
  },
  subTextContent: {
    fontFamily: 'Arial',
    fontSize: 16,
    marginTop: 17,
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    backgroundColor: '#7833FF',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
}));
